/**
 * Režim klienta. Určuje cestu k mapové stránce Mapio, která bude v mapové komponentě zobrazena.
 */
enum ClientMode {
    /**
     * Standardní režim, napojení na embed-editor s Angularem.
     */
    EMBED_EDITOR = 'embed-editor',

    /**
     * Zobrazení pro React Native, napojení na nového mobilního klienta.
     */
    REACT_NATIVE = 'new-client',

    /**
     * Napojení na nového React klienta.
     */
    NEW_EDITOR = ''
}

export default ClientMode;